var $b30b370424560d26$exports = {};
$b30b370424560d26$exports = {
    "valid": `\u{412}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D}`
};


export {$b30b370424560d26$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
